import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=c6062192&scoped=true"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"
import style0 from "./Principal.vue?vue&type=style&index=0&id=c6062192&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6062192",
  null
  
)

export default component.exports